// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";

import type { ImageLibraryItem } from "@modules/management/types";
import ImageLibraryBrowser from "@modules/management/components/image-library-browser";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "../../index";

type OwnProps = {
  onCancel: () => void,
  onSelect: (image: ImageLibraryItem) => void,
};

type Props = {
  ...OwnProps,
  ...PropsFromLocalize,
};

type ComponentState = {
  selected: ImageLibraryItem | null,
};

class ImageLibraryPickerModal extends Component<Props, ComponentState> {
  state = {
    selected: null,
  };

  onTileClick = (image: ImageLibraryItem) => {
    this.setState({ selected: image });
  };

  onSelect = () => {
    if (this.state.selected) {
      this.props.onSelect(this.state.selected);
    }
  };

  render() {
    const { t } = this.props;
    const { selected } = this.state;

    return (
      <Modal className="min-modal-width image-library-picker-modal">
        <ModalHeader tag="h3" toggle={this.props.onCancel}>
          {t("IMAGE_LIBRARY")}
        </ModalHeader>
        <ModalBody>
          <ImageLibraryBrowser
            columns={4}
            selectedId={selected ? selected.id : null}
            onImageClick={this.onTileClick}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {t("CANCEL")}
          </Button>
          <Button disabled={!selected} onClick={this.onSelect}>
            {t("SELECT")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(ImageLibraryPickerModal);
